import React from 'react'
import SbEditable from 'storyblok-react'
import GetMagazine from 'src/utils/GetMagazine'
import MagazineItem from './MagazineItem'

const CustomFourColumn = ({ blok }) => {

    return (
        <SbEditable content={blok} key={blok._uid}>
            <div className="bg-white mt-16 mb-20 px-6 lg:mt-24 lg:mb-28 lg:px-8">
                <div className="relative max-w-7xl mx-auto">
                    {blok.title && <h5 className="text-darkgrey mb-6 font-insights-display md:text-xl text-lg uppercase">{blok.title}</h5>}
                    <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4 md:gap-x-8 gap-y-12">
                        {GetMagazine(blok.items).map((item, index) => (
                            <MagazineItem {...item} key={index}/>
                        ))}
                    </div>
                </div>
            </div>
        </SbEditable>
    )
}

export default CustomFourColumn